<template>
	<div>
		<StateBar class="w-100p" />
		<div v-if="hasWsErrors && getWsErrors.length > 0" class="errors">
			<ul>
				<li v-for="(error, index) in getWsErrors" :key="index">{{ error }}</li>
			</ul>
		</div>
		<div class="fs-title text-center title">
			<h2>Ajánlatok összehasonlítása</h2>
		</div>

		<div class="con-1380">
			<div class="fs-desc text-justify top-text">
				<p>
					Kérjük, a termék kiválasztásához és a szerződés megkötéséhez szíveskedjen az Ezt választom
					nyomógombra kattintani.
				</p>
			</div>
			<div class="calc-top-row">
				<div class="calc-top-info fs-link">
					Az elérhető 7 termékből {{ getInsurerNumbers.insurer }} biztosító ajánlatát mutatjuk be, a többi
					biztosító a megadott adatok alapján nem adott ajánlatot. Legutóbbi adat frissítés: {{ now }}
					<span v-if="getOffersSum.false > 0">
						<br />
						Amennyiben további ajánlatok után érdeklődik, úgy forduljon hozzánk
						<a :href="`${location.origin}/elerhetosegeink`" target="_blank">elérhetőségeinken</a>
						.
					</span>
				</div>
				<div class="filterbuttons">
					<FilterButton :options="order" @orderBy="orderBy = $event" />
					<FilterButton :options="filter" />
				</div>
			</div>
		</div>

		<div class="con-1380 calc-full-content">
			<div class="calc-main-content comparison con-1080" id="printArea" v-if="offers !== null">
				<CalcResult
					:offers="offers.all"
					v-if="offers.all !== undefined && offers.all !== null"
					:isAll="true"
                    :print="print"
				/>
				<CalcResult v-for="(missing, index) in offers.missing" :key="index" :offers="missing" :print="print"/>
			</div>
			<div class="calc-main-content comparison con-1080" v-else-if="getLoading">
				<div class="text-center">Türelmét kérjük, épp a biztosítók ajánlatait gyűjtjük be.</div>
				<div class="placeholder" v-for="index in 5" :key="index"></div>
			</div>
			<CalcSidebar />
		</div>

		<div class="con-1380 mt-30px">
			<div class="fs-desc text-justify top-text">
				<p>
					A jelen tájékoztatásban foglalt online kalkulációs eredmények az Ön által megadott egyedi adatokból számított,
					az egyes biztosítóknál elérhető Minősített Fogyasztóbarát Otthonbiztosításra vonatkozó tájékoztatások.
				</p>
				<p>
					Az Összehasonlító oldalon egyszerű, táblázatos formában megtekinthető ajánlatok a biztosító nevét, a
					biztosítás fizetési ütemezését, a biztosítási összeget, a biztosítás csomagját (alapcsomag,
					kiegészítők), valamint a biztosítási díjat is tartalmazzák. Az Összehasonlító oldal használata
					megkönnyíti a tájékozódást, és a Minősített Fogyasztóbarát Otthonbiztosítás ajánlatok
					összehasonlítását.
					<br />
					<br />
					Felhívjuk figyelmét, hogy az Eurorisk - mint független biztosításközvetítő (biztosítási alkusz) -
					nem minősül a biztosító képviselőjének. Kínálatunkban csak azok a biztosítótársaságok szerepelnek,
					amelyek a Minősített Fogyasztóbarát Otthonbiztosítási ajánlatokat úgynevezett webszervíz
					technológiával nyújtják. Ez azt jelenti, hogy az E-otthonbiztositas.hu oldalon Ön által végzett
					kalkulációk esetén az adatok a biztosítók által szolgáltatott adatbázisokból származnak.
					<br />
					<br />
					Az Ezt választom gombra kattintással Ön a fenti tájékoztatás tudomásul vételét is tanúsítja.
				</p>
			</div>
		</div>

		<div class="con-1380 navBtn">
			<a class="navBtn-prev" @click="onPrev">Vissza</a>
            <a v-if="getIsBusinessProcess" class="navBtn-prev" @click="printPage">Nyomtatás</a>
            <a style="max-width: 200px;" v-if="getIsBusinessProcess" class="navBtn-prev" @click="sendToSKTrend">Nem MFO-t szeretnék</a>
		</div>

        <!-- error clearfix -->
        <div v-if="hasWsErrors" :style="{ height: getWsErrors.length*29+'px' }" style="width:100%"></div>

        <div class="banner" v-if="showBanner">
            <div class="banner-container">
                <div class="banner-text" v-if="!showBannerSuccess">
                    Ha a felsorolt ajánlatok nem nyerték el tetszését vagy kérdése van ezekkel kapcsolatban, akkor kollégánk keresi Önt és örömmel segít megtalálni az Önnek legmegfelelőbb biztosítást.
                </div>
                <div class="banner-text" v-if="showBannerSuccess">
                    Köszönjük jelzését! <b>Kollégánk hamarosan keresni fogja</b> Önt a megadott elérhetőségén.
                </div>

                <div
                    class="banner-button"
                    v-if="!showBannerSuccess" @click="clickNeedHelp">
                    Visszahívást kérek
                </div>
            </div>
            <div style="position: fixed;top:15px;right: 15px; color:white;cursor: pointer" @click="showBanner = false">
                <b>X</b>
            </div>
        </div>

	</div>
</template>

<script>
import CalcSidebar from '@/components/CalcSidebar.vue';
import CalcResult from '@/components/CalcResult.vue';
import FilterButton from '@/components/FilterButton.vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import moment from 'moment';
import _ from 'lodash';
import validation from '@/mixins/validation';
import SummaryView from "@/helpers/summaryView";

export default {
	mixins: [validation],
	async mounted() {
        if (this.getOutbuildingTypes.length === 0) {
            await this.fetchOutbuildingTypes();
        }

        if (this.getOutbuildingLocations.length === 0) {
            await this.fetchOutbuildingLocations();
        }

		this.setCurrentStep(5);
		if (this.getResponseOffers === null) {
			if (this.$route.params.hash !== null && this.$route.params.hash !== undefined) {
				await this.fetchCalculation(this.$route.params.hash);

				if (this.getCurrentUser === null) {
					await this.fetchCurrentUser();
				}
                if(!this.getIsCampaignCalculation && !this.getCalculation.is_new_contract && !this.getCalculation.on_my_own && moment(this.getCalculation.old_start_of_risk).diff(moment().format('yyyy-MM-DD'), 'days') < 31) {
                    this.popupHasClose(false);
                    await this.$instances.popup.$children[0].$children[0].asyncShow('TerminationOverdue');
                } else if(moment(this.getCalculation.start_of_risk).isSameOrBefore(moment().format('yyyy-MM-DD'))) {
					await this.$instances.popup.$children[0].$children[0].asyncShow('StartOfRiskChanger');
				}

				if (
					this.isLoggedIn &&
					this.getCalculation.user_id !== this.getCurrentUser.id &&
                    !(this.getIsBusinessProcess || this.getCalculation.consultant_id === this.getCurrentUser.id) &&
					!this.isCustomerService &&
					!this.isAdmin
				) {
					this.$router.push({ name: 'no-access' });
				} else {
					await this.calculate();
				}
			}
		}
        if(!this.getIsBusinessProcess) {
            setTimeout(() => {
                this.showBanner = true;
            }, 10000);
        }
    },
	components: {
		CalcSidebar,
		CalcResult,
		FilterButton,
	},
	computed: {
		...mapGetters([
			'getOffers',
			'getInsurerNumbers',
			'getResponseOffers',
			'getLoading',
			'getCalculation',
			'getOffersSum',
			'getWsErrors',
            'getIsBusinessProcess',
            'getRealEstate',
            'getInsuranceEventNameById',
            'getOutbuildingTypes',
            'getOutbuildingLocations',
            'getInsuranceEvents',
            'getOffersRaw',
            'getIsCampaignCalculation'
		]),
        ...mapGetters('contracting', [
            'getAllFormData',
        ]),
		...mapGetters('auth', ['isLoggedIn', 'getCurrentUser', 'isCustomerService', 'isAdmin']),
		hasWsErrors() {
			return process.env.MIX_APP_ENV !== 'production';
		},
		filter() {
			const list =
				this.getResponseOffers !== null
					? _.map(
							_.filter(this.getResponseOffers, offer => !_.has(offer, 'errors')),
							offer => {
								return {
									label: `${offer.insurer_name} | ${offer.product_name}`,
									offer: offer,
								};
							},
					  )
					: [];

			return {
				value: 'Összehasonlítás',
				icon: false,
				className: 'rightDrop',
				isOrder: false,
				list,
			};
		},
		offers() {
			return this.getOffers(this.orderBy);
		}
	},
	data() {
		return {
			prevLink: 'package-information',
			now: moment().format('yyyy.MM.DD.'),
			orderBy: null,
			order: {
				value: 'Rendezés',
				icon: true,
				isOrder: true,
				className: 'leftDrop',
				list: [
					{ label: 'Biztosító neve szerint növekvő', orderBy: 'insurer_name', direction: 'asc' },
					{ label: 'Biztosító neve szerint csökkenő', orderBy: 'insurer_name', direction: 'desc' },
					{ label: 'Biztosítási összeg szerint növekvő', orderBy: 'sum_fee', direction: 'asc' },
					{ label: 'Biztosítási összeg szerint csökkenő', orderBy: 'sum_fee', direction: 'desc' },
					{ label: 'Fizetendő díj növekvő', orderBy: 'frequency_fee', direction: 'asc' },
					{ label: 'Fizetendő díj csökkenő', orderBy: 'frequency_fee', direction: 'desc' },
				],
			},
			location: location,
            print: false,
            sendingToSKTrend: false,
            showBanner: false,
            showBannerSuccess: false,
		};
	},
	methods: {
		...mapMutations(['showPopup','popupHasClose']),
		...mapActions(['fetchCalculation', 'calculate', 'setNeedsHelp']),
		...mapActions('auth', ['fetchCurrentUser']),
        ...mapActions(['fetchOutbuildingTypes', 'fetchOutbuildingLocations']),
        async printPage() {
            if (!this.getLoading && this.offers) {
                this.print = true;
                let consultantName = "";
                let req = await window.axios.post('/vue/getCurrentConsultantName');
                if(req.data.success) {
                    consultantName = req.data.name;
                }
                this.$nextTick(function () {
                    // Get HTML to print from element
                    const prtHtml = document.getElementById('printArea').innerHTML;

                    // Get all stylesheets HTML
                    let stylesHtml = '';
                    for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
                        stylesHtml += node.outerHTML;
                    }

                    const summaryView = new SummaryView(
                        this.getCalculation,
                        null,
                        this.getAllFormData,
                        this.$store,
                        this.getRealEstate
                    );

                    const data = {
                        contractDetails: '',
                        realEstate: 'Ingatlan adatok',
                        mainMovables: 'Főépület ingóságok',
                        valuables: 'Értéktárgyak',
                        outbuildings: 'Melléképületek',
                        movables: 'Melléképület ingóságok',
                        buildings: 'Építmények',
                        containers: 'Tárolók',
                        containerMovables: 'Tároló ingóságok',
                        beneficiaryData: 'Balesetbiztosítás adatai',
                        insuranceEvents: 'Kiegészítő biztosítások',
                    };

                    const skip = ['Biztosító neve', 'Éves díj'];

                    this.print = false;
                    let html = `<h1>Kalkuláció adatai:</h1>`;
                    Object.keys(data).forEach(key => {
                        html += `<div style="font-weight: bold">${data[key]}</div>`;
                        if (summaryView[key] && summaryView[key].length > 0) {
                            summaryView[key].forEach(
                                ({title, value}) => {
                                    if (!skip.includes(title)) {
                                        html += `<div style="display: flex;flex-direction: row;break-inside: avoid;"><div style="padding: 0.5em; border: 1px solid lightgrey;  color: #777;width:20rem;margin:1px;background-color: #f8f8f8;">${title}</div><div style="padding: 0.5em;border: 1px solid lightgrey; width:20rem;margin:1px;">${value}</div></div>`;
                                    }
                                }
                            );
                        } else {
                            html += `<div style="display: flex;flex-direction: row;break-inside: avoid;">Nincs adat</div>`;
                        }
                    });

                    let insurer_count = 0;
                    for (const value of Object.values(this.getOffersRaw)) {
                        if (value.success === true) {
                            insurer_count++;
                        }
                    }
                    html += `
                    <h1 style="break-before: always;padding-bottom: 2rem">Kiegészítők összehasonlítása:</h1>
                    <div style="display: grid;row-gap:1px;column-gap:1px;grid-template-columns: 4.5fr repeat(${insurer_count}, 1fr);grid-auto-flow: dense;padding: 0.5rem;">
                    <div style="font-weight: bold;border: #9ca3af 1px solid">Kiegészítő biztosítás</div>`;
                    for (const value of Object.values(this.getOffersRaw)) {
                        if (value.success === true) {
                            html += `<div style="font-weight: bold;text-align: center; border: #9ca3af 1px solid">${value.insurer_name}</div>`;
                        }
                    }

                    for (const insurance_event of Object.values(this.getInsuranceEvents.extend)) {
                        html += `<div style="border: #9ca3af 1px solid">${insurance_event.name}</div>`;
                        for (const value of Object.values(this.getOffersRaw)) {
                            if (value.success !== true) {
                                continue;
                            }
                            if (value.insurance_events && value.insurance_events[insurance_event.id] && value.insurance_events[insurance_event.id]?.included === true) {
                                html += `<div style="text-align: center;border: #9ca3af 1px solid">*</div>`;
                            } else {
                                html += `<div style="border: #9ca3af 1px solid"></div>`;
                            }
                        }
                    }


                    html += `</div>`;

                    html += `
                    <h1 style="break-before: always">Ajánlatok:</h1>
                    <div style="display: grid;row-gap:1px;column-gap:1px;grid-template-columns: 1fr 1fr 1fr 1fr 1fr;grid-auto-flow: dense;padding: 0.5rem;">
                    <div
                        style="background-color: #f8f8f8;border: #9ca3af 1px solid;padding: 3px">
                        <strong>Biztosító</strong>
                    </div>
                    <div
                        style="background-color: #f8f8f8;border: #9ca3af 1px solid;padding: 3px">
                        <strong>Módozat</strong>
                    </div>
                    <div
                        style="background-color: #f8f8f8;border: #9ca3af 1px solid;padding: 3px">
                        <strong>Biztosítási összeg</strong>
                    </div>
                    <div
                        style="background-color: #f8f8f8;border: #9ca3af 1px solid;padding: 3px">
                        <strong>Általános ingóság</strong>
                    </div>
                    <div
                        style="background-color: #f8f8f8;border: #9ca3af 1px solid;padding: 3px">
                        <strong>Éves díj</strong>
                    </div>`;

                    Object.keys(this.offers.all).forEach(key => {
                        const offer = this.offers.all[key];
                        html += `<div style="grid-row: span 2;border: #9ca3af 1px solid;padding: 3px">${offer.insurer_full_name}</div>`;
                        html += `<div style="grid-row: span 2;border: #9ca3af 1px solid;padding: 3px">${offer.product_name}</div>`;
                        html += `<div style="border: #9ca3af 1px solid;padding: 3px">${offer.sum_fee !== null ? this.$options.filters.toCurrency(offer.sum_fee) : '-'} </div>`;
                        html += `<div style="border: #9ca3af 1px solid;padding: 3px">${offer.movables_value !== null ? this.$options.filters.toCurrency(offer.movables_value) : '-'}</div>`;
                        html += `<div style="border: #9ca3af 1px solid;padding: 3px">${this.$options.filters.toCurrency(offer.annual_fee)}</div>`;
                        html += `<div style="grid-column: span 3;border: #9ca3af 1px solid;padding: 3px">`;
                        let first = true;
                        offer.discounts.forEach(discount => {
                            if (first) {
                                first = false;
                            } else {
                                html += ', ';
                            }
                            html += discount.name + ': ' + (discount.percent === null ? this.$options.filters.toCurrency(discount.value) : `${discount.percent}%`);
                        });
                        html += `</div>`;
                    });

                    Object.keys(this.offers.missing).forEach(key => {
                        html += `<div style="grid-column: span 5;">Nem tartalmazza: `;
                        let first = true;
                        _.each(this.offers.missing[key].missings, missing => {
                            if (missing !== undefined && missing !== null) {
                                if (first) {
                                    first = false;
                                } else {
                                    html += ', ';
                                }
                                html += this.getInsuranceEventNameById(missing);
                            }
                        });
                        html += `</div>`;
                        this.offers.missing[key].forEach(offer => {
                            html += `<div style="grid-row: span 2;border: #9ca3af 1px solid;padding: 3px">${offer.insurer_full_name}</div>`;
                            html += `<div style="grid-row: span 2;border: #9ca3af 1px solid;padding: 3px">${offer.product_name}</div>`;
                            html += `<div style="border: #9ca3af 1px solid;padding: 3px">${offer.sum_fee !== null ? this.$options.filters.toCurrency(offer.sum_fee) : '-'} </div>`;
                            html += `<div style="border: #9ca3af 1px solid;padding: 3px">${offer.movables_value !== null ? this.$options.filters.toCurrency(offer.movables_value) : '-'}</div>`;
                            html += `<div style="border: #9ca3af 1px solid;padding: 3px">${this.$options.filters.toCurrency(offer.annual_fee)}</div>`;
                            html += `<div style="grid-column: span 3;border: #9ca3af 1px solid;padding: 3px">`;
                            let first = true;
                            offer.discounts.forEach(discount => {
                                if (first) {
                                    first = false;
                                } else {
                                    html += ', ';
                                }
                                html += discount.name + ': ' + (discount.percent === null ? this.$options.filters.toCurrency(discount.value) : `${discount.percent}%`);
                            });
                            html += `</div>`;
                        });
                    });


                    html += `</div>`;

                    html += '<div style="margin-top: 2rem">A Minősített Fogyasztóbarát Biztosításokat megismertem, kérem, a normál lakásbiztosítási kínálat megismertetését.</div>'
                    html += `<div style="break-after: page;display:flex; justify-content: space-between;margin-top: 1rem;margin-right:8rem;"><div>Kelt: ${this.now}</div><div style="display: flex;flex-direction: column;margin-top: 3rem;"><div>..........................................</div><div style="text-align: center">Aláírás</div></div></div>`;

                    // Open the print window
                    const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

                    WinPrint.document.write(`
                        <!DOCTYPE html>
                        <html>
                        <head>
                        ${stylesHtml}
                        <style>
                            .footer, .footer-space {
                                height: 20px;
                            }
                            .footer {
                              position: fixed;
                              bottom: 0;
                              width:100%;
                            }
                        </style>
                        </head>
                        <body>
                        <table>
                            <tbody>
                            <tr>
                                <td>
                                    <div class="content">
                                        <div style="break-after: always">
                                            ${html}
                                        </div>
                                        ${prtHtml}
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                            <tfoot>
                            <tr>
                                <td>
                                    <div class="footer-space">&nbsp;</div>
                                </td>
                            </tr>
                            </tfoot>
                        </table>
                        <div class="footer"><div style="display: flex;flex-flow: row; justify-content: space-between;"><div>Készült: ${moment().format("YYYY-MM-DD HH:mm:ss")}, E-otthonbiztositas.hu oldalon, azonosító: ${this.getCalculation?.id}</div> <div>${consultantName} által</div></div></div>
                      </body>
                      </html>`);

                    setTimeout(() => {
                        WinPrint.document.close();
                        WinPrint.focus();
                        WinPrint.print();
                        WinPrint.close();
                    }, 500);
                    this.print = false;
                });
            }
        },
        async sendToSKTrend() {
            if(this.sendingToSKTrend === false) {
                this.sendingToSKTrend = true;
                const response = await window.axios.post('/api/calculator/calculation/sendToSKTrend', {hash: this.$route.params.hash });
                if(response.data.success) {
                    this.showPopup('SKTrendSendSuccess');
                } else {
                    this.showPopup('SKTrendSendFail');
                }
                this.sendingToSKTrend = false;
            }
        },
        async clickNeedHelp() {
            if(await this.setNeedsHelp()) {
                this.showBannerSuccess = true;
            }
        }
	},
};
</script>

<style lang="scss">
.navBtn-prev {
	cursor: pointer;
}

.errors {
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	background: indianred;
	padding: 10px;
	z-index: 9999;
	color: white;
}

.title {
	position: relative;
	max-width: 1380px;
	margin: 0 auto;
	padding-left: 0;
	padding-right: 0;

	.back-button {
		display: block;
		position: absolute;
		left: 0;
		top: 50%;
		transform: translateY(-50%);
		font-size: 14px;
		line-height: 17px;
		color: #777778;
		cursor: pointer;

		&:hover {
			text-decoration: underline;
		}

		@media only screen and (max-width: 730px) {
			position: relative;
			margin-bottom: 20px;
		}
	}
}

.placeholder {
	width: 100%;
	min-height: 145px;
	margin: 25px 0;
	height: 145px;
	position: relative;
	border-radius: 4px;
	overflow: hidden;

	&:first-child {
		margin: 0;
	}

	&::before {
		content: '';
		display: block;
		position: absolute;
		left: -1081px;
		top: 0;
		height: 100%;
		width: 1081px;
		background: linear-gradient(to right, transparent 0%, #cccccc 50%, transparent 100%);
		animation: load 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;
	}
}

.top-text {
	font-size: 14px;
	line-height: 17px;
	max-width: 1140px;
	margin: 0 auto;

	@media only screen and (min-width: 1425px) {
		margin-left: 107px;
	}
}

@keyframes load {
	from {
		left: -1081px;
	}
	to {
		left: 100%;
	}
}

@keyframes expand{
    0%{height:0px}
    100%{height:110px}
}

.banner{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 110px;
    z-index: 99999;
    background-color: #1668ec;
    animation: expand 0.5s;
}
.banner-container{
    color: white;
    display: flex;
    justify-content: space-evenly;
    height: 110px;
    align-items: center;
    padding-left:5rem;
    padding-right:5rem;
    width:1100px;
    margin-left:auto;
    margin-right:auto;
    flex-wrap: wrap;
}
.banner-text{
    font-size: 14px;
    line-height: 17px;
    width:590px;
}
.banner-button {
    width:175px;
    font-size: 16px;
    line-height: 24px;
    min-height: 48px;
    font-weight: 500;
    box-sizing: border-box;
    border-radius: 4px;
    background: #fcc349;
    border: 1px solid #000000;
    color: #000000;
    transition: 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
@media screen and (max-width: 1100px) {
    .banner-container{
        padding-left:0;
        padding-right:0;
        width:100%;
        height: 130px;
    }
    .banner-text{
        width:100%;
        padding-left:2rem;
        padding-right:2rem;
    }
    .banner{
        height: 130px;
    }
}
</style>
